/* DomPickerComponent.js */

"use strict";
const Renderer = require("./DomPickerRenderer");
const BaseScheduleComponent = require("../../base/BaseScheduleComponent");

class DomPickerComponent extends BaseScheduleComponent {
    constructor(scheduleComp) {
        super(Renderer, scheduleComp);
    }
}
module.exports = DomPickerComponent;
